//Author June Leow
//Date Mar 25th, 2024
import {getReducer, getSetStateFunction, deleteAPICallGenerator, callBackGenerator, generateTooltip, showMessage} from '../../../../util/util';
import {Card, CardHeader, CardBody, Col, Row, Input, Modal, ModalHeader, ModalBody} from 'reactstrap';
import Compressor from 'compressorjs';
import Dropzone from 'react-dropzone'
import MySelect from '../../../util/my-select';
import {NavLink} from 'react-router-dom';
import InteriorDeficienciesUpdates from './interior-deficiencies-updates';
import React, {useReducer, useEffect} from 'react';
//initialize the state
const initialState = {
  floorPlanGuidelinePopUp:false
};


const belowGradeExitsEnum = [
  {value:'WALKUP', label:'Walkup'},
  {value:'WALKOUT', label:'Walkout'},
  {value:'GARAGE', label:'Garage'},
  {value:'CELLAR_DOOR', label:'Cellar Door'},
  {value:'INTERIOR', label:'Interior'},
]

const atticAccessEnum = [
  {value:'ATTIC_SCUTTLE', label:'Attic Scuttle'},
  {value:'DROP_STAIR', label:'Drop Stair'},
  {value:'PERMANENT_STAIRWELL', label:'Permanent Stairwell'},
  {value:'DOOR', label:'Door'},
  {value:'NONE_OBSERVED', label:'None Observed'},
]

const roomTypeEnum = [
  {value:'FOYER', label:'Foyer'},
  {value:'LIVING_ROOM', label:'Living Room'},
  {value:'DINING_ROOM', label:'Dining Room'},
  {value:'KITCHEN', label:'Kitchen'},
  {value:'DEN', label:'Den'},
  {value:'FAMILY_ROOM', label:'Family Room'},
  {value:'REC_ROOM', label:'Rec Room'},
  {value:'BEDROOM', label:'Bedroom'},
  {value:'FULL_BATH', label:'Full Bath'},
  {value:'HALF_BATH', label:'Half Bath'},
  {value:'LAUNDRY_ROOM', label:'Laundry Room'},
  {value:'HALL', label:'Hall'},
  {value:'LIBRARY', label:'Library'},
  {value:'MEDIA', label:'Media'},
  {value:'OFFICE', label:'Office'},
  {value:'UTILITY_ROOM', label:'Utility Room'},
  {value:'WORKSHOP', label:'Workshop'},
  {value:'BUTLERS_PANTRY', label:'Butlers Pantry'},
  {value:'OTHER_ROOM', label:'Other Room'},
  {value:'UNFINISHED_BASEMENT', label:'Unfinished Basement'}
]

const fixtureTypeEnum = [
  {value:'SINK', label:'Sink'},
  {value:'TOILET', label:'Toilet'},
  {value:'TUB_SHOWER', label:'Tub Shower'},
  {value:'WALK_IN_SHOWER', label:'Walk in Shower'},
  {value:'TUB_W_NO_SHOWER', label:'Tub with no Shower'},
  {value:'FREESTANDING_TUB', label:'Freestanding Tub'},
  {value:'APPLIANCE_HOOKUP', label:'Appliance Hookup'},
  {value:'LAUNDRY_HOOKUP', label:'Laundry Hookup'},
  {value:'POT_FILLER', label:'Pot Filler'},
  {value:'JETTED_TUB', label:'Jetted Tub'},
  {value:'ROUGH_IN', label:'Rough In'},
  {value:'NONE_OBSERVED', label:'None Observed'},
]

const roomFeatureTypeEnum = [
  {value:'FIREPLACE', label:'Fireplace'},
  {value:'WOOD_STOVE', label:'Wood Stove'},
  {value:'BUILT_INS', label:'Built Ins'},
  {value:'WET_BAR', label:'Wet Bar'},
  {value:'WALK_IN_CLOSET', label:'Walk in Closet'},
  {value:'PANTRY', label:'Pantry'},
  {value:'NONE', label:'None'},
]

const disabledStyling = {border:'none', background:'#fff', padding:'0',paddingLeft:'2px', height:'auto',WebkitAppearance:'none'};


//reducer function that perform state update
const reducer = getReducer();


const Levels  = (props)=>{
  const controller = new AbortController();

  const [state, dispatch] = useReducer(reducer,initialState);

  //wrapper function
  const setState = getSetStateFunction(dispatch);

  const apiCallBack = callBackGenerator(setState);
  const httpDelete = deleteAPICallGenerator(props, {signal:controller.signal});

  //run only once when component is loaded
  useEffect(()=>{
    return ()=> controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  //non API call but simpyl manage state
  const numberOnly= (e) => {
    const isControlKey = ["Backspace", "Delete", "ArrowLeft", "ArrowRight"].includes(e.key);
    if (!isControlKey && e.key.match(/[^0-9]/)) {
      e.preventDefault();
    }
  };

  const getCompressRatio = (size)=>{
    let ratio = 0.8;
    size = size/1000/1000;
  
    if(size>=20)
      ratio = 0.05;
    else if(size>=15)
      ratio = 0.05;
    else if(size>=10)
      ratio = 0.1;
    else if(size>=8)
      ratio = 0.2;
    else if(size>=6)
      ratio = 0.4;
    else if(size>=4)
      ratio = 0.5;
    else if(size>=3)
      ratio = 0.6;
    else if(size>=2)
      ratio = 0.7;
  
    return ratio;
  }

  const floorPlanGuidelinePopUpToggle = ()=>{
    setState({floorPlanGuidelinePopUp:!state.floorPlanGuidelinePopUp});
  }

  const updateFileDescription = (index, index2, index3, field, description)=>{
    let newUPD = Object.assign({}, props.upd);
    let rooms = newUPD.property.buildings[props.index].units[props.index2].levels?newUPD.property.buildings[props.index].units[props.index2].levels[index].rooms.slice():null;
    let target = rooms[index2][field]?rooms[index2][field]:[];
    if(target &&  target[index2]){
      target[index2].description = description;
    }

    newUPD.property.buildings[props.index].units[props.index2].levels[index].rooms = rooms;
    props.update(newUPD);
  }

  //function trigger for dropzone react.
  //this function contians two list of files, the accepted and rejected file per the configuration
  const onDrop = (acceptedFiles, rejectedFiles, index, index2, field, type='Misc', typeFk=0, description='')=>{
    // let limit = 3;
    //
    // if(type==='Floor Plan')
    //   limit = 1;
    //
    // if(props[field].length+ acceptedFiles.length>limit){
    //   let numberOfAvailable = limit - props[field].length;
    //   acceptedFiles = acceptedFiles.slice(0, numberOfAvailable);
    //   showMessage('error', 'Maximum number of photo uploaded and could not accept any more photos.');
    // }

    let existingFiles = [];
    if(acceptedFiles.length>0){
      for(let i=0;i<acceptedFiles.length;i++){
        existingFiles.push(acceptedFiles[i]);
        let name = existingFiles[i].name;
        let token = name.split('.');
        let extension = '';

        if(token.length>0){
          extension = token[token.length-1];
          extension = extension.toLowerCase();
        }

        if(extension!=='png'&&extension!=='jpg'&&extension!=='jpeg'){
          showMessage('error','Please upload only PNG/JPG image.');
        }
        else if((acceptedFiles[i].size/1000/1000)<1 && type!=='FLOOR_PLAN'){
          showMessage('error','Image quality is too low, please use photo that range from 1MB to 50MB.');
        }
        else if((acceptedFiles[i].size/1000/1000)>50){
          showMessage('error','Image size is too large, please use photo that range from 1MB to 50MB.');
        }
        else{
          let compressRatio = getCompressRatio(acceptedFiles[i].size);
          new Compressor(acceptedFiles[i], {
            quality: compressRatio, // 0.6 can also be used, but its not recommended to go below.
            success: (compressedResult) => {
              // compressedResult has the compressed file.
              // Use the compressed file to upload the images to your server.        
              let compressedFile = new File([compressedResult], acceptedFiles[i].name);

              const reader = new FileReader();
              reader.onload = () => {
                const fileAsBinaryString = reader.result;
                let base64 = btoa(fileAsBinaryString);
                let newUPD = Object.assign({}, props.upd);
                let rooms = newUPD.property.buildings[props.index].units[props.index2].levels?newUPD.property.buildings[props.index].units[props.index2].levels[index].rooms.slice():null;
   
                let target = rooms[index2][field]?rooms[index2][field]:[];
                target.push({name:acceptedFiles[i].name, base64:base64, status:'Pending', size:compressedFile.size, type:type, typeFk:rooms[index2].ID, description:description});
                rooms[index2][field] = target;
                newUPD.property.buildings[props.index].units[props.index2].levels[index].rooms = rooms;
                props.update(newUPD);
              }
              reader.readAsBinaryString(compressedFile);
            },
          });
        }
      }
    }
  }

  const onDrop2 = (acceptedFiles, rejectedFiles, index, field, type='Misc', typeFk=0, description='')=>{
    // let limit = 3;
    //
    // if(type==='Floor Plan')
    //   limit = 1;
    //
    // if(props[field].length+ acceptedFiles.length>limit){
    //   let numberOfAvailable = limit - props[field].length;
    //   acceptedFiles = acceptedFiles.slice(0, numberOfAvailable);
    //   showMessage('error', 'Maximum number of photo uploaded and could not accept any more photos.');
    // }

    let existingFiles = [];
    if(acceptedFiles.length>0){
      for(let i=0;i<acceptedFiles.length;i++){
        existingFiles.push(acceptedFiles[i]);
        let name = existingFiles[i].name;
        let token = name.split('.');
        let extension = '';

        if(token.length>0){
          extension = token[token.length-1];
          extension = extension.toLowerCase();
        }

        if(extension!=='png'&&extension!=='jpg'&&extension!=='jpeg'){
          showMessage('error','Please upload only PNG/JPG image.');
        }
        else if((acceptedFiles[i].size/1000/1000)<1 && type!=='FLOOR_PLAN'){
          showMessage('error','Image quality is too low, please use photo that range from 1MB to 50MB.');
        }
        else if((acceptedFiles[i].size/1000/1000)>50){
          showMessage('error','Image size is too large, please use photo that range from 1MB to 50MB.');
        }
        else{
          let compressRatio = getCompressRatio(acceptedFiles[i].size);
          new Compressor(acceptedFiles[i], {
            quality: compressRatio, // 0.6 can also be used, but its not recommended to go below.
            success: (compressedResult) => {
              // compressedResult has the compressed file.
              // Use the compressed file to upload the images to your server.        
              let compressedFile = new File([compressedResult], acceptedFiles[i].name);

              const reader = new FileReader();
              reader.onload = () => {
                const fileAsBinaryString = reader.result;
                let base64 = btoa(fileAsBinaryString);
                let newUPD = Object.assign({}, props.upd);
                let levels = newUPD.property.buildings[props.index].units[props.index2].levels?newUPD.property.buildings[props.index].units[props.index2].levels.slice():null;
   
                let target = levels[index][field]?levels[index][field]:[];
                target.push({name:acceptedFiles[i].name, base64:base64, status:'Pending', size:compressedFile.size, type:type, typeFk:levels[index].ID, description:description});
                levels[index][field] = target;
                newUPD.property.buildings[props.index].units[props.index2].levels = levels;
                props.update(newUPD);
              }
              reader.readAsBinaryString(compressedFile);
            },
          });
        }
      }
    }
  }

  const removeFloorPlan = (field,index, index2)=>{
    let newUPD = Object.assign({}, props.upd);
    let levels = newUPD.property.buildings[props.index].units[props.index2].levels?newUPD.property.buildings[props.index].units[props.index2].levels:[];
    let target = levels[index][field].slice();

    let targetToDelete = target[index2];

    if(targetToDelete.ID && targetToDelete.ID!==-1){
      let successCallBack = ()=>{
        target.splice(index2, 1);
        levels[index][field] = target;
        newUPD.property.buildings[props.index].units[props.index2].levels  = levels;
        props.update(newUPD);
      };
      successCallBack = successCallBack.bind(this);
      deletePhoto(targetToDelete.ID, props, successCallBack);
    }
    else{
      target.splice(index2, 1);
      levels[index][field] = target;
      newUPD.property.buildings[props.index].units[props.index2].levels  = levels;
      props.update(newUPD);
    }
  }

  const removeFile = (field,index, index2, index3)=>{
    let newUPD = Object.assign({}, props.upd);
    let rooms = newUPD.property.buildings[props.index].units[props.index2].levels?newUPD.property.buildings[props.index].units[props.index2].levels[index].rooms.slice():null;
    let target = rooms[index2][field].slice();

    let targetToDelete = target[index3];

    if(targetToDelete.ID && targetToDelete.ID!==-1){
      let successCallBack = ()=>{
        target.splice(index3, 1);
        rooms[index2][field] = target;
        newUPD.property.buildings[props.index].units[props.index2].levels[index].rooms = rooms;
        props.update(newUPD);
      };
      successCallBack = successCallBack.bind(this);
      deletePhoto(targetToDelete.ID, props, successCallBack);
    }
    else{
      target.splice(index3, 1);
      rooms[index2][field] = target;
      newUPD.property.buildings[props.index].units[props.index2].levels[index].rooms = rooms;
      props.update(newUPD);
    }
  }

  const getFixtureTypeEnumLabel = (value)=>{
    for(let i=0;i<fixtureTypeEnum.length;i++){
      if(fixtureTypeEnum[i].value===value)
        return fixtureTypeEnum[i].label;
    }
    return value;
  }

  const getRoomFeatureTypeLabel = (value)=>{
    for(let i=0;i<roomFeatureTypeEnum.length;i++){
      if(roomFeatureTypeEnum[i].value===value)
        return roomFeatureTypeEnum[i].label;
    }
    return value;
  }

  const getRoomTypeLabel = (value)=>{
    for(let i=0;i<roomTypeEnum.length;i++){
      if(roomTypeEnum[i].value===value)
        return roomTypeEnum[i].label;
    }
    return value;
  }

  const getBelowGradeExitsLabel = (value)=>{
    for(let i=0;i<belowGradeExitsEnum.length;i++){
      if(belowGradeExitsEnum[i].value===value)
        return belowGradeExitsEnum[i].label;
    }
    return value;
  }

  const getAtticAccessLabel = (value)=>{
    for(let i=0;i<atticAccessEnum.length;i++){
      if(atticAccessEnum[i].value===value)
        return atticAccessEnum[i].label;
    }
    return value;
  }

  const removeLevel = (index)=>{
    let newUPD = Object.assign({}, props.upd);
    let levels = newUPD.property.buildings[props.index].units[props.index2].levels?newUPD.property.buildings[props.index].units[props.index2].levels.slice():null;
    if(levels.length<=1 && index===0){
      showMessage('error', 'You cannot delete this level.');
    }
    else{
      levels.splice(index, 1);
      newUPD.property.buildings[props.index].units[props.index2].levels = levels;
      props.update(newUPD);
    }
  }

  const addLevel = ()=>{
    let newUPD = Object.assign({}, props.upd);
    let levels = newUPD.property.buildings[props.index].units[props.index2].levels?newUPD.property.buildings[props.index].units[props.index2].levels.slice():null;
    levels.push({belowGradeExits:[], atticAccess:[], gla:[], rooms:[{imageRoom:[], imageLivingroom:[], imageKitchen:[], imageBathroom:[], imageOven:[], appliances:{},interiorUpdates:[], interiorDeficiencies:[], plumbingFixtures:[], roomFeatures:[{roomFeatureType:[]}]}]});
    newUPD.property.buildings[props.index].units[props.index2].levels = levels;
    props.update(newUPD);
  }

  const addRoom = (index)=>{
    let newUPD = Object.assign({}, props.upd);
    let rooms = newUPD.property.buildings[props.index].units[props.index2].levels[index].rooms?newUPD.property.buildings[props.index].units[props.index2].levels[index].rooms.slice():null;
    rooms.push({imageRoom:[], imageLivingroom:[], imageKitchen:[], imageBathroom:[], imageOven:[], appliances:{},interiorUpdates:[], interiorDeficiencies:[], plumbingFixtures:[], roomFeatures:[{roomFeatureType:[]}]});
    newUPD.property.buildings[props.index].units[props.index2].levels[index].rooms = rooms;
    props.update(newUPD);
  }

  const removeRoom = (index, index2)=>{
    let newUPD = Object.assign({}, props.upd);
    let rooms = newUPD.property.buildings[props.index].units[props.index2].levels[index].rooms?newUPD.property.buildings[props.index].units[props.index2].levels[index].rooms.slice():null;
    if(rooms.length<=1 && index2===0){
      showMessage('error', 'You cannot delete this room.');
    }
    else{
      rooms.splice(index2, 1);
      let roomType = rooms[index2];
      let gla = newUPD.property.buildings[props.index].units[props.index2].levels[index].gla? newUPD.property.buildings[props.index].units[props.index2].levels[index].gla.slice():[];
      for(let i=0;i<gla.length;i++){
        if(gla[i].name===getRoomTypeLabel(roomType) && gla[i].width && gla[i].width==='' && gla[i].height && gla[i].height==='' && gla[i].sqft && gla[i].sqft===''){
          gla.splice(i,1);
          break;
        }
      }
      newUPD.property.buildings[props.index].units[props.index2].levels[index].gla = gla;

      newUPD.property.buildings[props.index].units[props.index2].levels[index].rooms = rooms;
      props.update(newUPD);
    }
  }

  const updateRoomDetail = (index, index2, field, value)=>{
    let newUPD = Object.assign({}, props.upd);
    let rooms = newUPD.property.buildings[props.index].units[props.index2].levels[index].rooms?newUPD.property.buildings[props.index].units[props.index2].levels[index].rooms.slice():null;
    let gla = newUPD.property.buildings[props.index].units[props.index2].levels[index].gla?newUPD.property.buildings[props.index].units[props.index2].levels[index].gla.slice():[];

    if(field==='roomType'){
      for(let i=0;i<gla.length;i++){
        if(gla[i].name===getRoomTypeLabel(rooms[index2][field]) && (!gla[i].width || gla[i].width==='') && (!gla[i].length || gla[i].length==='') && (!gla[i].sqft || gla[i].sqft==='')){
          gla.splice(i,1);
          break;
        }
      }
      if(value!=='UNFINISHED_BASEMENT')
        gla.push({name:getRoomTypeLabel(value), width:'', length:'', sqft:''});
      newUPD.property.buildings[props.index].units[props.index2].levels[index].gla = gla;
    }

    rooms[index2][field] = value;
    newUPD.property.buildings[props.index].units[props.index2].levels[index].rooms = rooms;

    props.update(newUPD);
  }

  const updateApplicanceDetail = (index, index2, field, value)=>{
    let newUPD = Object.assign({}, props.upd);
    let rooms = newUPD.property.buildings[props.index].units[props.index2].levels[index].rooms?newUPD.property.buildings[props.index].units[props.index2].levels[index].rooms.slice():null;

    rooms[index2].appliances[field] = value;
    newUPD.property.buildings[props.index].units[props.index2].levels[index].rooms = rooms;
    props.update(newUPD);
  }

  const removeRoomFeature = (index, index2, index3)=>{
    let newUPD = Object.assign({}, props.upd);
    let rooms = newUPD.property.buildings[props.index].units[props.index2].levels[index].rooms?newUPD.property.buildings[props.index].units[props.index2].levels[index].rooms.slice():null;

    if(rooms[index2].roomFeatures && rooms[index2].roomFeatures[0]){
      let roomFeatures = rooms[index2].roomFeatures[0].roomFeatureType?rooms[index2].roomFeatures[0].roomFeatureType.slice():[];
      if(roomFeatures.length>0){
        roomFeatures.splice(index3, 1);
      }
      rooms[index2].roomFeatures[0].roomFeatureType = roomFeatures;
    }
    newUPD.property.buildings[props.index].units[props.index2].levels[index].rooms = rooms;
    props.update(newUPD);
  }

  const removePlumbingFixture = (index, index2, index3)=>{
    let newUPD = Object.assign({}, props.upd);
    let rooms = newUPD.property.buildings[props.index].units[props.index2].levels[index].rooms?newUPD.property.buildings[props.index].units[props.index2].levels[index].rooms.slice():null;

    if(rooms[index2].plumbingFixtures){
      let plumbingFixtures = rooms[index2].plumbingFixtures?rooms[index2].plumbingFixtures.slice():[];
      if(plumbingFixtures.length>0){
        plumbingFixtures.splice(index3, 1);
      }
      rooms[index2].plumbingFixtures = plumbingFixtures;
    }
    newUPD.property.buildings[props.index].units[props.index2].levels[index].rooms = rooms;
    props.update(newUPD);
  }

  const updateRoomFeaturesDetail = (index, index2, value)=>{
    let newUPD = Object.assign({}, props.upd);
    let rooms = newUPD.property.buildings[props.index].units[props.index2].levels[index].rooms?newUPD.property.buildings[props.index].units[props.index2].levels[index].rooms.slice():null;

    if(rooms[index2].roomFeatures && rooms[index2].roomFeatures[0]){
      let roomFeatures = rooms[index2].roomFeatures[0].roomFeatureType?rooms[index2].roomFeatures[0].roomFeatureType.slice():[];
      
      if(value==='NONE'){
        roomFeatures = [{roomFeatureType:'NONE'}];
        rooms[index2].roomFeatures = [{roomFeatureType:roomFeatures}];
      }
      else{
        let index = roomFeatures.map(function(e) { return e.roomFeatureType; }).indexOf('NONE');
        if(index!==-1){
          roomFeatures = [{roomFeatureType:value}];
          rooms[index2].roomFeatures = [{roomFeatureType:roomFeatures}];
        }
        else{
          let index = roomFeatures.map(function(e) { return e.roomFeatureType; }).indexOf(value);
          if(index===-1)
            roomFeatures.push({roomFeatureType:value});
          rooms[index2].roomFeatures = [{roomFeatureType:roomFeatures}];
        }
      }
    }
    else{
      rooms[index2].roomFeatures = [{roomFeatureType:[value]}];
    }

    newUPD.property.buildings[props.index].units[props.index2].levels[index].rooms = rooms;
    props.update(newUPD);
  }

  const updatePlumbingFixturesDetail = (index, index2, value)=>{
    let newUPD = Object.assign({}, props.upd);
    let rooms = newUPD.property.buildings[props.index].units[props.index2].levels[index].rooms?newUPD.property.buildings[props.index].units[props.index2].levels[index].rooms.slice():null;

    if(rooms[index2].plumbingFixtures){
      let plumbingFixtures = rooms[index2].plumbingFixtures?rooms[index2].plumbingFixtures.slice():[];
      
      if(value==='NONE_OBSERVED'){
        plumbingFixtures = [{fixtureType:'NONE_OBSERVED'}];
        rooms[index2].plumbingFixtures = plumbingFixtures;
      }
      else{
        for(let i=0;i<plumbingFixtures.length;i++){
          if(plumbingFixtures[i].fixtureType==='NONE_OBSERVED'){
            plumbingFixtures = [];
            break;
          }
        }
        plumbingFixtures.push({fixtureType:value});
        rooms[index2].plumbingFixtures = plumbingFixtures;
      }

    }
    else{
      rooms[index2].plumbingFixtures = [{fixtureType:value}];
    }

    newUPD.property.buildings[props.index].units[props.index2].levels[index].rooms = rooms;
    props.update(newUPD);
  }

  const removeGLACalculations = (index, index2) => {
      let newUPD = Object.assign({}, props.upd);
      let gla = newUPD.property.buildings[props.index].units[props.index2].levels[index].gla?newUPD.property.buildings[props.index].units[props.index2].levels[index].gla.slice():[];
      gla.splice(index2, 1);
      newUPD.property.buildings[props.index].units[props.index2].levels[index].gla = gla;
      props.update(newUPD);
    }

  const addGLA = (index) => {
    let newUPD = Object.assign({}, props.upd);
    let gla = newUPD.property.buildings[props.index].units[props.index2].levels[index].gla?newUPD.property.buildings[props.index].units[props.index2].levels[index].gla.slice():[];
    
    gla.push({});
    newUPD.property.buildings[props.index].units[props.index2].levels[index].gla = gla;
    console.log(gla) 
    console.log(newUPD)
    props.update(newUPD);
  }

  const updateGLACalculation = (field, index, index2, value) => {
    let newUPD = Object.assign({}, props.upd);
    let gla = newUPD.property.buildings[props.index].units[props.index2].levels[index].gla?newUPD.property.buildings[props.index].units[props.index2].levels[index].gla.slice():[];
    gla[index2][field] = value;
    if(field==='irregular'){
      gla[index2]['width'] = '';
      gla[index2]['length'] = '';
    }
    newUPD.property.buildings[props.index].units[props.index2].levels[index].gla = gla;
    props.update(newUPD);
  }

  const calculateSqft = (width, length) => {
    const w = parseFloat(width);
    const l = parseFloat(length);

    if (isNaN(w) || isNaN(l)) return '';

    const sqft = w * l;

    // Round UP to 2 decimal places
    return Math.ceil(sqft * 100) / 100;
  };

  //filter gla input
  const handleGLAInputChange = (field, index, index2, event) => {
    console.log('handle GLA input change')
    const input = event.target.value;
    console.log(input);
    let newUPD = Object.assign({}, props.upd);

    // Allow:
    // - empty
    // - whole numbers (10)
    // - decimals (10.4, .4)
    const regex = /^(\d+(\.\d*)?|\.\d+)$/;
    console.log(regex.test(input))
    if (input === '' || regex.test(input)) {
      updateGLACalculation(field, index, index2, input);
    }
    else{
      let sanitizedText = input
        .replace(/[^0-9.]/g, '')        // remove non-numeric/non-dot
        .replace(/(\..*)\./g, '$1');    // keep only first dot
      updateGLACalculation(field, index, index2, sanitizedText);
    }
    if(field==='width'){
      let length = newUPD.property.buildings[props.index].units[props.index2].levels[index].gla[index2].length;
      if(input!=='' && length!==''){
        let sqft = calculateSqft(input, length);
        updateGLACalculation('sqft', index, index2, sqft);
      }
    }
    if(field==='length'){
      let width = newUPD.property.buildings[props.index].units[props.index2].levels[index].gla[index2].width;
      if(input!=='' && width!==''){
        let sqft = calculateSqft(width, input);
        updateGLACalculation('sqft', index, index2, sqft);
      }
    }
  };


  const updateLevelDetail = (index, field, value)=>{
    let newUPD = Object.assign({}, props.upd);
    let levels = newUPD.property.buildings[props.index].units[props.index2].levels?newUPD.property.buildings[props.index].units[props.index2].levels.slice():null;
    levels[index][field] = value;
    newUPD.property.buildings[props.index].units[props.index2].levels = levels;
    props.update(newUPD);
  }

  const updateLevelBelowGradeExits = (index, value)=>{
    let newUPD = Object.assign({}, props.upd);
    let belowGradeExits = newUPD.property.buildings[props.index].units[props.index2].levels[index].belowGradeExits?newUPD.property.buildings[props.index].units[props.index2].levels[index].belowGradeExits.slice():null;
    if(belowGradeExits.indexOf(value)===-1)
      belowGradeExits.push(value);
    newUPD.property.buildings[props.index].units[props.index2].levels[index].belowGradeExits = belowGradeExits;
    props.update(newUPD);
  }

  const updateAtticAccess = (index, value)=>{
    let newUPD = Object.assign({}, props.upd);
    let atticAccess = newUPD.property.buildings[props.index].units[props.index2].levels[index].atticAccess?newUPD.property.buildings[props.index].units[props.index2].levels[index].atticAccess.slice():null;
    
    if(value==='NONE_OBSERVED')
      atticAccess = ['NONE_OBSERVED'];
    else{
      for(let i=0;i<atticAccess.length;i++){
        if(atticAccess[i]==='NONE_OBSERVED')
          atticAccess = [];
      }
      if(atticAccess.indexOf(value)===-1)
        atticAccess.push(value);
    }
    
    newUPD.property.buildings[props.index].units[props.index2].levels[index].atticAccess = atticAccess;
    props.update(newUPD);
  }

  const removeAtticAccess = (index, index2, value)=>{
    let newUPD = Object.assign({}, props.upd);
    let atticAccess = newUPD.property.buildings[props.index].units[props.index2].levels[index].atticAccess?newUPD.property.buildings[props.index].units[props.index2].levels[index].atticAccess.slice():null;
    atticAccess.splice(index2, 1);
    newUPD.property.buildings[props.index].units[props.index2].levels[index].atticAccess = atticAccess;
    props.update(newUPD);
  }

  const removeLevelBelowGradeExits = (index, index2)=>{
    let newUPD = Object.assign({}, props.upd);
    let belowGradeExits = newUPD.property.buildings[props.index].units[props.index2].levels[index].belowGradeExits?newUPD.property.buildings[props.index].units[props.index2].levels[index].belowGradeExits.slice():null;
    belowGradeExits.splice(index2, 1);
    newUPD.property.buildings[props.index].units[props.index2].levels[index].belowGradeExits = belowGradeExits;
    props.update(newUPD);
  }

  //API call
  const deletePhoto = (ID, props, successCallBack) => {
    let callBack = apiCallBack([],[()=>{successCallBack()}])
    httpDelete('uniformPropertyDataset/photo/'+ID, '', 'Oops, something went wrong and could not delete this photo. Please try again later.', callBack);
  }

  //render
  return <div>
    {!props.disabled?<div className="align-right">
      <NavLink to="#" onClick={(e)=>addLevel()}><i className="fa fa-plus green-color"/> Add Level</NavLink>
    </div>:null}
    {props.upd.property.buildings[props.index].units[props.index2].levels.map(
      (level, index)=>{
        return <div key={index} id={`level-${props.index}-${props.index2}-${index}`}>
            <Card>
              <CardHeader><i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeLevel(index)}/> Level #{index+1}</CardHeader>
              <CardBody>
                <label>{!props.disabled?<font color="red">*</font>:null}Identify the level number starting with the lowest number on the lowest floor and highest number on the top floor. {generateTooltip('levelNumber'+index, 'User to enter a number for each level in sequential order starting at the bottom, regardless of whether a level has earth contact. User to begin with the lowest level being equal to one.')}</label>
                <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} required={!props.disabled} pattern="[0-9]*" onKeyDown={numberOnly} type="text" value={level.levelNumber} onChange={(e)=>updateLevelDetail(index,'levelNumber', e.target.value)}/>
                <Row>
                  <Col sm="6">
                    <label>{!props.disabled?<font color="red">*</font>:null}Indicate for each level if it is below-grade. {generateTooltip('belowGrade'+index,'Indicate for each level if it is below-grade. A level is considered to be below-grade if any portion of it is below-ground level, regardless of the quality of finish or the window area of any room. True should be selected for \'Below-Grade\' if any portion of any wall for a level is partially or wholly below-grade. ')}</label>
                    <MySelect
                      type="select"
                      required={!props.disabled}
                      disabled={props.disabled}
                      style={props.disabled?disabledStyling:{}}
                      value={level.belowGrade}
                      onChange={(v)=>updateLevelDetail(index, 'belowGrade', v)}
                      options={[{label:"True",value:"True"},{label:"False",value:"False"}]}
                    />
                  </Col>
                  <Col sm="6">
                    <label>{!props.disabled && level.belowGrade==='True'?<font color="red">*</font>:null}How is the below-grade level accessed and /or egressed? {generateTooltip('belowGradeExits'+index,'User to indicate the type(s) of exits to/from below grade areas (indicated by the selection of \'Below Grade\'. The user should select the type(s) of exits for either external access and/or internal access.')}</label>
                    <MySelect
                      type="select"
                      required={!props.disabled && level.belowGrade==='True'}
                      disabled={props.disabled}
                      style={props.disabled?disabledStyling:{}}
                      value={level.belowGradeExits}
                      onChange={(v)=>updateLevelBelowGradeExits(index, v)}
                      options={belowGradeExitsEnum}
                    />
                    {
                      level.belowGradeExits.map(
                        (belowGrade, index2)=>{
                          return <span className="my-badge3" key={index2} style={{marginRight:'5px', padding:'10px'}}>
                            <i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeLevelBelowGradeExits(index, index2)}/> {getBelowGradeExitsLabel(belowGrade)}
                          </span>
                        }
                      )
                    }
                  </Col>
                </Row>
                <label>{!props.disabled?<font color="red">*</font>:null}Is there any finished area on this level with ceilings lower than 7 feet? {generateTooltip('levelLowCeiling'+index,'User to indicate whether any portion of the level has ceilings less than 7 feet above the floor. True - An area of the level has ceilings lower than 7 feet. False - The Level\'s ceilings are greater than equal to 7 feet.')}</label>
                <MySelect
                  type="select"
                  required={!props.disabled}
                  disabled={props.disabled}
                  style={props.disabled?disabledStyling:{}}
                  value={level.levelLowCeiling}
                  onChange={(v)=>updateLevelDetail(index, 'levelLowCeiling', v)}
                  options={[{label:"True",value:"True"},{label:"False",value:"False"}]}
                />
                <br/>
                <label>{!props.disabled?<font color="red">*</font>:null}Can an attic be accessed from this level? {generateTooltip('attic'+index,'User to indicate whether an attic is accessible from the level. True = Attic can be accessed from this level. False = Attic cannot be accessed from this level.')}</label>
                <MySelect
                  type="select"
                  required={!props.disabled}
                  disabled={props.disabled}
                  style={props.disabled?disabledStyling:{}}
                  value={level.attic}
                  onChange={(v)=>updateLevelDetail(index, 'attic', v)}
                  options={[{label:"True",value:"True"},{label:"False",value:"False"}]}
                />
                <br/>
                {level.attic==='True'?<Row>
                  <Col sm="6">
                    <label>{!props.disabled?<font color="red">*</font>:null}How is the attic accessed? {generateTooltip('atticAccess'+index,'User to select the option that best describes the type of access to the attic when the attic indicator is set to \'TRUE\'.')}</label>
                    <MySelect
                      type="select"
                      required={!props.disabled}
                      disabled={props.disabled}
                      style={props.disabled?disabledStyling:{}}
                      value={level.attic}
                      onChange={(v)=>updateAtticAccess(index, v)}
                      options={atticAccessEnum}
                    />
                    {
                      level.atticAccess.map(
                        (access, index2)=>{
                          return <span className="my-badge3" key={index2} style={{marginRight:'5px', padding:'10px'}}>
                            <i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeAtticAccess(index, index2)}/> {getAtticAccessLabel(access)}
                          </span>
                        }
                      )
                    }
                  </Col>
                  <Col sm="6">
                    <label>{!props.disabled?<font color="red">*</font>:null}Is the attic accessed from this level above this level or at the same level? {generateTooltip('atticAccessLocation'+index,'Some levels have attic access through a small door, or hatch on the same level as a finished living area.  If this is the type of attic access indicate True. If the Attic accessed from this level is above this level indicate False')}</label>
                    <MySelect
                      type="select"
                      required={!props.disabled}
                      disabled={props.disabled}
                      style={props.disabled?disabledStyling:{}}
                      value={level.atticAccessLocation}
                      onChange={(v)=>updateLevelDetail(index, 'atticAccessLocation', v)}
                      options={[{label:"True",value:"True"},{label:"False",value:"False"}]}
                    />
                  </Col>
                </Row>:null}
                <br/>
                <label>{!props.disabled?<font color="red">*</font>:null}What is the total area of this level, finished, non-standard finished and unfinished? {generateTooltip('totalArea'+index, 'User to input the total floor area for each level. Total floor area includes all finished and unfinished regardless of ceiling height. This field is not used in calculating GLA.')}</label>
                <div className="red-color" style={{fontSize:'13px'}}>
                  <i className="fa fa-check green-color"/> Include all livable areas and garage <br/>
                  <i className="fa fa-check green-color"/> Clearly distinguish finished vs unfinished areas  <br/>
                  <i className="fa fa-check green-color"/> Total must match the floor plan <br/>
                  <i className="fa fa-times red-color"/> Do NOT include porch, patio, or open-to-below areas <br/>
                </div>
                <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} required={!props.disabled} pattern="[0-9]*" onKeyDown={numberOnly} type="text" value={level.totalArea} onChange={(e)=>updateLevelDetail(index,'totalArea', e.target.value)}/>
                <br/>
                <label>{!props.disabled?<font color="red">*</font>:null}Finished Area of this level that meet the ANSI standard for finished area. {generateTooltip('finishedArea'+index, 'User to input the finished living area for each level of the dwelling. Finished area is defined as any space within the dwelling  that is finished to the standards of the home with a ceiling height no less than 7 feet above the floor. The finished area must be provided in square feet. Finished area that is below grade will be counted separately from those that are not below grade. ')}</label>
                <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} required={!props.disabled} pattern="[0-9]*" onKeyDown={numberOnly} type="text" value={level.finishedArea} onChange={(e)=>updateLevelDetail(index,'finishedArea', e.target.value)}/>
                <br/>
                <label>{!props.disabled?<font color="red">*</font>:null}Unfinished Area of this level. {generateTooltip('unfinishedArea'+index, 'User to input any area of a level that is unfinished.')}</label>
                <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} required={!props.disabled} pattern="[0-9]*" onKeyDown={numberOnly} type="text" value={level.unfinishedArea} onChange={(e)=>updateLevelDetail(index,'unfinishedArea', e.target.value)}/>
                <br/>
                <label>{!props.disabled?<font color="red">*</font>:null}Provide the  Non-standard Finished Area within the dwelling or each structure as applicable. {generateTooltip('nonStandardFinishedArea'+index, 'User to input any area of a level that is finished to the same degree of the property but does not meet the ANSI standard of  finished area due to the height of the ceiling.')}</label>
                <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} required={!props.disabled} pattern="[0-9]*" onKeyDown={numberOnly} type="text" value={level.nonStandardFinishedArea} onChange={(e)=>updateLevelDetail(index,'nonStandardFinishedArea', e.target.value)}/>

                <br/>
                {!props.disabled?<div className="align-right">
                  <NavLink to="#" onClick={(e)=>addRoom(index)}><i className="fa fa-plus green-color"/> Add Room</NavLink>
                </div>:null}
                <div className="my-divider"/>
                {
                  level.rooms.map(
                    (room, index2)=>{
                      return <div key={index2} id={`room-${props.index}-${props.index2}-${index}-${index2}`}>
                        <Card>
                          <CardHeader><i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeRoom(index, index2)}/> Room #{index2+1}</CardHeader>
                          <CardBody>
                            <label>{!props.disabled?<font color="red">*</font>:null}What type of room is this? Select the option that best matches. {generateTooltip('roomType'+index2,'User to select the best option to identify the room. A bedroom is defined as having a window and door that can be closed. The bedroom should have two means of egress, i.e. the door and window.')}</label>
                            <MySelect
                              type="select"
                              required={!props.disabled}
                              disabled={props.disabled}
                              style={props.disabled?disabledStyling:{}}
                              value={room.roomType}
                              onChange={(v)=>updateRoomDetail(index, index2, 'roomType', v)}
                              options={roomTypeEnum}
                            />
                            <br/>
                            {room.roomType==='OTHER_ROOM'?<div>
                              <label>{!props.disabled?<font color="red">*</font>:null}You selected 'Other' room type. Provide a name for the room.</label>
                              <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} required={!props.disabled} type="text" value={room.otherRoomTypeDescription} onChange={(e)=>updateRoomDetail(index,index2, 'otherRoomTypeDescription', e.target.value)}/>
                              <br/>
                            </div>:null}
                            {room.roomType==='KITCHEN'?<div>
                              <label>{!props.disabled?<font color="red">*</font>:null}Is there a range/oven or a range/oven hook up in this room?</label>
                              <MySelect
                                type="select"
                                required={!props.disabled}
                                disabled={props.disabled}
                                style={props.disabled?disabledStyling:{}}
                                value={room.appliances.rangeOvenExists}
                                onChange={(v)=>updateApplicanceDetail(index, index2, 'rangeOvenExists', v)}
                                options={[{label:"True",value:"True"},{label:"False",value:"False"}]}
                              />
                              <br/>
                              {room.appliances.rangeOvenExists==='True'?<div>
                                <label>{!props.disabled}Image(s) of range oven</label>
                                  <br/>
                                  <input
                                    tabIndex={-1}
                                    autoComplete="off"
                                    style={{ opacity: 0, height: 0, width:0 }}
                                    value={room.imageOven&&room.imageOven.length>0?" ":""}
                                    required={!props.disabled}
                                  />
                                  <div>
                                    <Dropzone hidden={props.disabled} onDrop={(accepted, rejected)=>{onDrop(accepted, rejected, index, index2, 'imageOven', 'OVEN_RANGE', 0)}} className="my-dropzone">
                                    {
                                      ({getRootProps, getInputProps}) => (
                                        <div
                                          {...getRootProps({
                                            className: 'my-dropzone',
                                          })}
                                        >
                                          <input {...getInputProps()} />
                                          <center>Choose files to upload</center>
                                        </div>
                                      )
                                    }
                                    </Dropzone>
                                    {
                                      !room.imageOven?null:room.imageOven.map(
                                        (photo, index3)=>{
                                          return <div key={index3} className="display-inline" style={{width:200, height:270, margin:5, verticalAlign:'top'}}>
                                            <div>
                                              <i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFile('imageOven',index, index2, index3)}/> {photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}
                                            </div>
                                            <img alt="pic" width="200" height="200" src={photo.status==='Pending'?"data:image/png;base64, "+photo.base64:photo.presign_url}/>
                                            <div style={{marginTop:'5px'}}/>
                                            {!photo.ID?<div><Input type="text" placeholder="Description of photo" value={photo.description} onChange={(e)=>updateFileDescription(index, index2, index3, 'imageOven', e.target.value)}/>
                                            <div style={{marginTop:'5px'}}/></div>:<i>{photo.description}</i>}
                                          </div>
                                        }
                                      )
                                    }
                                  </div>
                                  <br/>
                              </div>:null}
                            </div>:null}
                            <label>{!props.disabled?<font color="red">*</font>:null}Do any of the following features exist within the room? Choose from the list of options. {generateTooltip('roomFeatures'+index,'Indicate if there are any features from the list provided for each room identified.  Select all that apply. ')}</label>
                            <MySelect
                              type="select"
                              required={!props.disabled}
                              disabled={props.disabled}
                              style={props.disabled?disabledStyling:{}}
                              value={room.roomFeatures[0].roomFeatureType && room.roomFeatures[0].roomFeatureType.length>0?" ":""}
                              onChange={(v)=>updateRoomFeaturesDetail(index, index2, v)}
                              options={roomFeatureTypeEnum}
                            />
                            {
                              room.roomFeatures[0].roomFeatureType.map(
                                (roomFeature, index3)=>{
                                  return <span className="my-badge3" key={index3} style={{marginRight:'5px', padding:'10px'}}>
                                  <i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeRoomFeature(index, index2, index3)}/> {getRoomFeatureTypeLabel(roomFeature.roomFeatureType)}
                                </span>
                                }
                              )
                            }
                            <br/>
                            {(room.roomType==='FULL_BATH' || room.roomType==='HALF_BATH' || room.roomType==='KITCHEN' || room.roomType==='BUTLERS_PANTRY' || room.roomType==='LAUNDRY_ROOM')?<div>
                              <label>{!props.disabled?<font color="red">*</font>:null}List all plumbing and fixtures in this room. {generateTooltip('plumbingFixtures'+index,'Indicate the fixture for every bathroom, kitchen, laundry room, and butler’s pantry in the structure. Select all that apply.')}</label>
                              <MySelect
                                type="select"
                                required={!props.disabled}
                                disabled={props.disabled}
                                style={props.disabled?disabledStyling:{}}
                                value={room.plumbingFixtures && room.plumbingFixtures.length>0?" ":""}
                                onChange={(v)=>updatePlumbingFixturesDetail(index, index2, v)}
                                options={fixtureTypeEnum}
                              />
                              <div className="red-color" style={{fontSize:'13px'}}>
                                <i className="fa fa-check green-color"/> Select ALL applicable fixtures (multi-select) <br/>
                                <i className="fa fa-check green-color"/> Include appliance hookups (e.g., washer/dryer) <br/>
                                <i className="fa fa-check green-color"/> Ensure selections match the photos<br/>
                                <i className="fa fa-times red-color"/> Do NOT leave missing items or deficiencies unreported <br/>
                              </div>
                              {
                                room.plumbingFixtures.map(
                                  (fixtureType, index3)=>{
                                    return <span className="my-badge3" key={index3} style={{marginRight:'5px', padding:'10px'}}>
                                    <i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removePlumbingFixture(index, index2, index3)}/> {getFixtureTypeEnumLabel(fixtureType.fixtureType)}
                                  </span>
                                  }
                                )
                              }
                              <br/>
                            </div>:null}
                            <div className="my-divider"/>
                            <br/>
                            <label><font color="red">***</font>Best practice: Take images of rooms at a minimum capturing from two opposite corners in the room and providing floor to ceiling coverage.</label>
                            {
                              room.roomType!=='KITCHEN' && room.roomType!=='LIVING_ROOM' && room.roomType!=='FULL_BATH' && room.roomType!=='HALF_BATH' ? <div>
                                <label>{!props.disabled?<font color="red">*</font>:null}Image(s) of view of the room</label>
                                <br/>
                                <input
                                  tabIndex={-1}
                                  autoComplete="off"
                                  style={{ opacity: 0, height: 0, width:0 }}
                                  value={room.imageRoom&&room.imageRoom.length>0?" ":""}
                                  required={!props.disabled}
                                />
                                <div>
                                  <Dropzone hidden={props.disabled} onDrop={(accepted, rejected)=>{onDrop(accepted, rejected, index, index2, 'imageRoom', 'ROOM', 0)}} className="my-dropzone">
                                  {
                                    ({getRootProps, getInputProps}) => (
                                      <div
                                        {...getRootProps({
                                          className: 'my-dropzone',
                                        })}
                                      >
                                        <input {...getInputProps()} />
                                        <center>Choose files to upload</center>
                                      </div>
                                    )
                                  }
                                  </Dropzone>
                                  {
                                    !room.imageRoom?null:room.imageRoom.map(
                                      (photo, index3)=>{
                                        return <div key={index3} className="display-inline" style={{width:200, height:270, margin:5, verticalAlign:'top'}}>
                                          <div>
                                            <i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFile('imageRoom',index, index2, index3)}/> {photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}
                                          </div>
                                          <img alt="pic" width="200" height="200" src={photo.status==='Pending'?"data:image/png;base64, "+photo.base64:photo.presign_url}/>
                                          <div style={{marginTop:'5px'}}/>
                                          {!photo.ID?<div><Input type="text" placeholder="Description of photo" value={photo.description} onChange={(e)=>updateFileDescription(index, index2,  index3, 'imageRoom', e.target.value)}/>
                                          <div style={{marginTop:'5px'}}/></div>:<i>{photo.description}</i>}
                                        </div>
                                      }
                                    )
                                  }
                                </div>
                              </div>:null
                            }

                            {
                              room.roomType==='KITCHEN' ? <div>
                                <label>{!props.disabled?<font color="red">*</font>:null}Image(s) of view of the kitchen</label>
                                <br/>
                                <input
                                  tabIndex={-1}
                                  autoComplete="off"
                                  style={{ opacity: 0, height: 0, width:0 }}
                                  value={room.imageKitchen&&room.imageKitchen.length>0?" ":""}
                                  required={!props.disabled}
                                />
                                <div>
                                  <Dropzone hidden={props.disabled} onDrop={(accepted, rejected)=>{onDrop(accepted, rejected, index, index2, 'imageKitchen', 'KITCHEN', 0)}} className="my-dropzone">
                                  {
                                    ({getRootProps, getInputProps}) => (
                                      <div
                                        {...getRootProps({
                                          className: 'my-dropzone',
                                        })}
                                      >
                                        <input {...getInputProps()} />
                                        <center>Choose files to upload</center>
                                      </div>
                                    )
                                  }
                                  </Dropzone>
                                  {
                                    !room.imageKitchen?null:room.imageKitchen.map(
                                      (photo, index3)=>{
                                        return <div key={index3} className="display-inline" style={{width:200, height:270, margin:5, verticalAlign:'top'}}>
                                          <div>
                                            <i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFile('imageKitchen',index, index2, index3)}/> {photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}
                                          </div>
                                          <img alt="pic" width="200" height="200" src={photo.status==='Pending'?"data:image/png;base64, "+photo.base64:photo.presign_url}/>
                                          <div style={{marginTop:'5px'}}/>
                                          {!photo.ID?<div><Input type="text" placeholder="Description of photo" value={photo.description} onChange={(e)=>updateFileDescription(index, index2, index3,  'imageKitchen', e.target.value)}/>
                                          <div style={{marginTop:'5px'}}/></div>:<i>{photo.description}</i>}
                                        </div>
                                      }
                                    )
                                  }
                                </div>
                              </div>:null
                            }

                            {
                              room.roomType==='LIVING_ROOM' ? <div>
                                <label>{!props.disabled?<font color="red">*</font>:null}Image(s) of view of the living room</label>
                                <br/>
                                <input
                                  tabIndex={-1}
                                  autoComplete="off"
                                  style={{ opacity: 0, height: 0, width:0 }}
                                  value={room.imageLivingroom&&room.imageLivingroom.length>0?" ":""}
                                  required={!props.disabled}
                                />
                                <div>
                                  <Dropzone hidden={props.disabled} onDrop={(accepted, rejected)=>{onDrop(accepted, rejected, index, index2, 'imageLivingroom', 'LIVING_ROOM', 0)}} className="my-dropzone">
                                  {
                                    ({getRootProps, getInputProps}) => (
                                      <div
                                        {...getRootProps({
                                          className: 'my-dropzone',
                                        })}
                                      >
                                        <input {...getInputProps()} />
                                        <center>Choose files to upload</center>
                                      </div>
                                    )
                                  }
                                  </Dropzone>
                                  {
                                    !room.imageLivingroom?null:room.imageLivingroom.map(
                                      (photo, index3)=>{
                                        return <div key={index3} className="display-inline" style={{width:200, height:270, margin:5, verticalAlign:'top'}}>
                                          <div>
                                            <i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFile('imageLivingroom',index, index2, index3)}/> {photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}
                                          </div>
                                          <img alt="pic" width="200" height="200" src={photo.status==='Pending'?"data:image/png;base64, "+photo.base64:photo.presign_url}/>
                                          <div style={{marginTop:'5px'}}/>
                                          {!photo.ID?<div><Input type="text" placeholder="Description of photo" value={photo.description} onChange={(e)=>updateFileDescription(index, index2, index3,  'imageLivingroom', e.target.value)}/>
                                          <div style={{marginTop:'5px'}}/></div>:<i>{photo.description}</i>}
                                        </div>
                                      }
                                    )
                                  }
                                </div>
                              </div>:null
                            }

                            {
                              room.roomType==='FULL_BATH' || room.roomType==='HALF_BATH' ? <div>
                                <label>{!props.disabled?<font color="red">*</font>:null}Image(s) of view of the bathroom</label>
                                <br/>
                                <input
                                  tabIndex={-1}
                                  autoComplete="off"
                                  style={{ opacity: 0, height: 0, width:0 }}
                                  value={room.imageBathroom&&room.imageBathroom.length>0?" ":""}
                                  required={!props.disabled}
                                />
                                <div>
                                  <Dropzone hidden={props.disabled} onDrop={(accepted, rejected)=>{onDrop(accepted, rejected, index, index2, 'imageBathroom', 'BATHROOM', 0)}} className="my-dropzone">
                                  {
                                    ({getRootProps, getInputProps}) => (
                                      <div
                                        {...getRootProps({
                                          className: 'my-dropzone',
                                        })}
                                      >
                                        <input {...getInputProps()} />
                                        <center>Choose files to upload</center>
                                      </div>
                                    )
                                  }
                                  </Dropzone>
                                  {
                                    !room.imageBathroom?null:room.imageBathroom.map(
                                      (photo, index3)=>{
                                        return <div key={index3} className="display-inline" style={{width:200, height:270, margin:5, verticalAlign:'top'}}>
                                          <div>
                                            <i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFile('imageBathroom',index, index2, index3)}/> {photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}
                                          </div>
                                          <img alt="pic" width="200" height="200" src={photo.status==='Pending'?"data:image/png;base64, "+photo.base64:photo.presign_url}/>
                                          <div style={{marginTop:'5px'}}/>
                                          {!photo.ID?<div><Input type="text" placeholder="Description of photo" value={photo.description} onChange={(e)=>updateFileDescription(index, index2, index3,  'imageBathroom', e.target.value)}/>
                                          <div style={{marginTop:'5px'}}/></div>:<i>{photo.description}</i>}
                                        </div>
                                      }
                                    )
                                  }
                                </div>
                              </div>:null
                            }
                            <br/>
                            <InteriorDeficienciesUpdates {...props} index={props.index} index2={props.index2} index3={index} index4={index2}/>
                          </CardBody>
                        </Card>
                        <br/>
                      </div>
                    }
                  )
                }
                <br/>
                <i><b>Please upload one floor plan for each level on this unit</b></i><br/>
                
                <Row>
                  <Col sm="6">
                    <div className="red-color">
                      A floor plan must be software-generated (not hand drawn), show the exterior footprint and interior layout of the dwelling unit(s) and include the following:
                    </div>
                    <ul className="red-color">
                      <li>clearly distinguish finished vs unfinished areas,</li>
                      <li>all exterior walls with legible dimensions reported to the nearest tenth of a foot,</li>
                      <li>all interior walls, doorways, staircases, exterior ingress/egress, and labels for each room,</li>
                      <li>all levels of the dwelling, and</li>
                      <li>the calculations that demonstrate how the square footage(s) was derived.</li>
                      <li>...</li>
                    </ul>
                    <div className="red-color">
                      <b>Sloped Ceilings</b><br/>
                      Exclude areas less than 5 ft. Include 5–7 ft in GLA only if ≥50% of the room is ≥7 ft (excluding less than 5 ft areas). Otherwise, label as Non-Standard Finished or Unfinished.
                    </div>
                    <NavLink to="#" onClick={floorPlanGuidelinePopUpToggle}>View detailed guideline</NavLink><br/><br/>
                    <label>Blueprint lengend</label><br/>
                    <img width="500" src="https://homevms-public-resources.s3.us-west-1.amazonaws.com/ansi_guideline.png"/>
                  </Col>
                  <Col sm="6">
                    <label>Sample Floor Plan</label><br/>
                    <img width="680" src="https://homevms-public-resources.s3.us-west-1.amazonaws.com/sample_floor_plan_v2.png?20260415"/>
                  </Col>
                </Row>
                <Modal className="my-modal-wide" isOpen={state.floorPlanGuidelinePopUp} toggle={floorPlanGuidelinePopUpToggle} >
                  <ModalHeader hidden={true} toggle={floorPlanGuidelinePopUpToggle}>Floor Plan Guideline</ModalHeader>
                  <ModalBody>
                    <div>
                      <Row>
                        <Col sm="6">
                          <br/>
                          <div>
                            <i className="fa fa-check green-color"/> Must be software-generated (NOT hand drawn)<br/>
                            <i className="fa fa-check green-color"/> Separate finish and unfinished area<br/>
                            <i className="fa fa-check green-color"/> Show full exterior footprint of the structure<br/>
                            <i className="fa fa-check green-color"/> Include all exterior walls with dimensions<br/>
                            <i className="fa fa-check green-color"/> Include all interior details:<br/>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Interior walls<br/>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Doorways and openings<br/>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Staircases<br/>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Exterior ingress/egress<br/>
                            <i className="fa fa-check green-color"/> Label ALL rooms clearly (e.g., Bedroom, Kitchen, Living Room)<br/>
                            <i className="fa fa-check green-color"/> Include ALL levels of the dwelling:<br/>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Main level<br/>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Upper levels<br/>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Basement (if applicable)<br/>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- ADU / additional structures<br/>
                            <i className="fa fa-check green-color"/> Calculations must demonstrate how total square footage is derived<br/>
                            <i className="fa fa-check green-color"/> Totals must be consistent across report and floor plan<br/>
                            <i className="fa fa-check green-color"/> Include garage in floor plan and area calculations<br/>
                            <i className="fa fa-check green-color"/> Separate structures must have their own floor plan:<br/>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- ADU<br/>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Barn<br/>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Detached garage<br/>
                            <i className="fa fa-check green-color"/> Ensure measurements are accurate and verified before submission<br/>
                            <i className="fa fa-check green-color"/> Follow ANSI guidelines:<br/>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Above grade vs below grade must be correctly represented<br/>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Areas with ceiling height less than 7 ft may not count as finished living area<br/>
                            <i className="fa fa-check green-color"/> Common areas (hallways, closets, stairs) must be accounted for in total area<br/>
                          </div>
                        </Col>
                        <Col sm="6">
                          <br/>
                          <i className="fa fa-times red-color"/> Do NOT submit incomplete floor plans (missing walls, labels, or dimensions)<br/>
                          <i className="fa fa-times red-color"/> Do NOT mismatch area totals between floor plan and report<br/>
                          <i className="fa fa-times red-color"/> Do NOT exclude garage or include non-livable areas (porch/patio) in totals<br/>
                          <i className="fa fa-times red-color"/> Do NOT combine multiple structures into a single floor plan<br/><br/>
                        </Col>
                      </Row>
                      
                    </div>
                  </ModalBody>
                </Modal>
                
                <label>{!props.disabled?<font color="red">*</font>:null}Image(s) of unit floor plan</label>
                <br/>
                <input
                  tabIndex={-1}
                  autoComplete="off"
                  style={{ opacity: 0, height: 0, width:0 }}
                  value={level.imageFloorPlan&&level.imageFloorPlan.length>0?" ":""}
                  required={!props.disabled}
                />
                <div>
                  <Dropzone hidden={props.disabled} onDrop={(accepted, rejected)=>{onDrop2(accepted, rejected, index, 'imageFloorPlan', 'FLOOR_PLAN', level.ID)}} className="my-dropzone">
                  {
                    ({getRootProps, getInputProps}) => (
                      <div
                        {...getRootProps({
                          className: 'my-dropzone',
                        })}
                      >
                        <input {...getInputProps()} />
                        <center>Choose files to upload</center>
                      </div>
                    )
                  }
                  </Dropzone>
                  {
                    !level.imageFloorPlan?null:level.imageFloorPlan.map(
                      (photo, index2)=>{
                        return <div key={index2} className="display-inline" style={{width:200, height:270, margin:5, verticalAlign:'top'}}>
                          <div>
                            <i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFloorPlan('imageFloorPlan',index, index2)}/> {photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}
                          </div>
                          <img alt="pic" width="200" height="200" src={photo.status==='Pending'?"data:image/png;base64, "+photo.base64:photo.presign_url}/>
                          {!photo.ID?<div><Input type="text" placeholder="Description of photo" value={photo.description} onChange={(e)=>updateFileDescription(index, index2, 'imageFloorPlan', e.target.value)}/>
                          <div style={{marginTop:'5px'}}/></div>:<i>{photo.description}</i>}
                        </div>
                      }
                    )
                  }
                </div>
                <br/>
                <Card>
                  <CardHeader>
                    <Row>
                      <Col sm="6">
                        <label>GLA</label>
                      </Col>
                      <Col sm="6" className="align-right">
                        {!props.disabled?<NavLink to="#" onClick={(e)=>addGLA(index)}><i className="fa fa-plus green-color"/> Add GLA</NavLink>:null}
                      </Col>
                    </Row>
                  </CardHeader>
                  <CardBody>
                    <label>🔸 Please enter measurements in decimal feet <font color="red">(tenths)</font>. Examples: 10.4 = 10 feet 4.8 inches, 10 = 10.0 feet, .4 = 0.4 feet. Do not use feet (') or inch (") symbols.</label><br/>
                    <label>🔸 For your sqft please round it up to two decimal.</label><br/>
                    <label>🔸 Note: Hallways are part of GLA but not considered a room. Please click "Add GLA" and check the "Common Area" box to enter hallway measurements.</label><br/>
                    <label>🔸 If the room or common area has an irregular shape, check the “Irregular Shape” box. You may then enter the total square footage only — Length and Width are not required in that case.</label><br/>
                    <label>🔸 You can delete a specific entry by clicking the <i className="fa fa-times red-color"/> icon.</label>
                    <br/><br/>
                    {
                      level.gla.map(
                        (glaCalculation, index2)=>{
                          console.log(glaCalculation)
                          return <div key={index+'|'+index2}>
                          <input type="checkbox" checked={glaCalculation.common_area === true || glaCalculation.common_area === 'true'} onClick={(e)=>updateGLACalculation('common_area',index, index2, glaCalculation.common_area === true || glaCalculation.common_area === 'true' ? false : true)}/> Common Area &nbsp;&nbsp;
                          <input type="checkbox" checked={glaCalculation.irregular === true || glaCalculation.irregular === 'true'} onClick={(e)=>updateGLACalculation('irregular',index, index2, glaCalculation.irregular === true || glaCalculation.irregular === 'true' ? false : true)}/> Irregular Shape
                          <Row>
                            <Col sm="3">
                              <i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeGLACalculations(index, index2)}/>&nbsp;<label>{!props.disabled?<font color="red">*</font>:null}Name</label><br/>
                              <Input required={!props.disabled} style={props.disabled?disabledStyling:{}} disabled={props.disabled} type="text" value={glaCalculation.name} onChange={(e)=>updateGLACalculation('name',index, index2, e.target.value)}/>
                            </Col>
                            <Col sm="3">
                              <label>{(!props.disabled&&!glaCalculation.irregular)?<font color="red">*</font>:null}Length</label><br/>
                              <Input required={!props.disabled && glaCalculation.irregular} style={props.disabled?disabledStyling:{}} disabled={(props.disabled||glaCalculation.irregular === true || glaCalculation.irregular === 'true')} type="text" value={glaCalculation.length} onChange={(e) => handleGLAInputChange('length', index, index2, e)}/>
                            </Col>
                            <Col sm="3">
                              <label>{(!props.disabled&&!glaCalculation.irregular)?<font color="red">*</font>:null}Width</label><br/>
                              <Input required={!props.disabled && glaCalculation.irregular} style={props.disabled?disabledStyling:{}} disabled={(props.disabled||glaCalculation.irregular === true || glaCalculation.irregular === 'true')} type="text" value={glaCalculation.width} onChange={(e) => handleGLAInputChange('width', index, index2, e)}/>
                            </Col>
                            <Col sm="3">
                              <label>{!props.disabled?<font color="red">*</font>:null}Sqft</label><br/>
                              <Input required={!props.disabled} style={props.disabled?disabledStyling:{}} disabled={props.disabled} type="text" value={glaCalculation.sqft} onChange={(e) => handleGLAInputChange('sqft', index, index2, e)}/>
                            </Col>
                          </Row>
                          <br/>
                        </div>
                        }
                      )
                    }
                  </CardBody>
                </Card>
              </CardBody>
            </Card>
            <br/>
        </div>
      }
    )}
    <br/>
  </div>
}


export default Levels;